module.exports = __webpack_public_path__ + "img/chart_image.847ab43a.png";